export function fetchBulletins(apiUrl, accessToken, limit = 0) {

  return fetch(`${apiUrl}/v1/bulletins` + (limit ? `?limit=${limit}` : ''), {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchRecentBulletins(apiUrl, accessToken, limit = 0) {

  return fetch(`${apiUrl}/v1/bulletins/recent` + (limit ? `?limit=${limit}` : ''), {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}